// extracted by mini-css-extract-plugin
module.exports = {"connect_another_way":"connectAnotherWayCard_connect_another_way__LF7s8"};